import { render, staticRenderFns } from "./set.vue?vue&type=template&id=b751b0b2&scoped=true&"
import script from "./set.vue?vue&type=script&lang=js&"
export * from "./set.vue?vue&type=script&lang=js&"
import style0 from "./set.vue?vue&type=style&index=0&lang=css&"
import style1 from "./set.vue?vue&type=style&index=1&id=b751b0b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b751b0b2",
  null
  
)

export default component.exports